import { useEffect, useState } from "react";

export const usePermissions = (isBroadcaster) => {
  const [granted, setGranted] = useState(!isBroadcaster);

  useEffect(() => {
    if (isBroadcaster) {
      navigator.mediaDevices
        .getUserMedia({ audio: true, video: true })
        .then((stream) => {
          stream.getTracks().forEach((track) => track.stop());
          setGranted(true);
        })
        .catch((err) => {
          console.error("Permission error:", err);
          setGranted(false);
        });
    }
  }, [isBroadcaster]);

  return granted;
};
